import './style.sass';
import { TopNavbar } from '../../components';
import { Row, Col, Container } from 'react-bootstrap';
import GreenTick from '../../assets/img/icons/greeenTick.svg';
import Step1 from '../Step01';
import DullTick from '../../assets/img/icons/dullTick.svg';
import { useEffect, useState } from 'react';
import Step2 from '../Step02';
import Step3 from '../Step03';
import Step4 from '../Step04';
import { useSelector } from 'react-redux';

export default function Steps() {
  const currentHref = window.location.href;
  const currentUrl = new URL(currentHref);
  const searchParams = currentUrl.searchParams;
  const stepValue = parseInt(searchParams.get('step')) || 1;
  const [questionState] = useSelector((state) => {
    return [state.review.singleQuestion];
  });
  const [count, setCount] = useState(stepValue);
  const [question, setQuestion] = useState(1);
  function updateCount() {
    const newCount = count + 1;
    currentUrl.searchParams.set('step', newCount);
    window.history.replaceState(null, '', currentUrl);
    setCount(newCount);
  }

  useEffect(() => {
    if (questionState) {
      setQuestion(questionState);
    }
  }, [questionState]);
  return (
    <>
      <div>
        <div className="expamBarWrape">
          <div
            style={{
              background: 'linear-gradient(270deg, #0269B7 0%, #4EA2E2 99.24%)',
            }}
          >
            <TopNavbar steps={true} IsLoggedIn={true} />
            <br />
            <Container>
              <div className="examBarContainer">
                <Row>
                  <Col md={8}>
                    <h1 className="headingExam">
                      {question?.quiz?.alias ? question?.quiz?.alias : question?.section?.title} -{' '}
                      {question?.section?.title} Section <br />
                      {/* Section 44 Questions */}
                    </h1>
                  </Col>
                  <Col md={4}>
                    <Row>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
          <div style={{ background: '#F2F2F2' }}>
            <Container>
              <div className="stepCount">
                <Row style={{ margin: '0px' }}>
                  <Col
                    style={{ borderBottom: '4px solid #3CA333' }}
                    className=""
                    md="3"
                    sm="3"
                    xs="3"
                  >
                    <div className="colFlex">
                      <img src={GreenTick} />
                      <div style={{ marginLeft: '10px' }}>
                        <h1 className="stepText">Step1</h1>
                        <p className="stepTextDetail">Categorize</p>
                      </div>
                    </div>
                  </Col>
                  <Col
                    style={
                      count > 1
                        ? {
                            display: 'flex',
                            borderBottom: '4px solid #3CA333',
                            padding: '0px',
                          }
                        : {
                            display: 'flex',
                            borderBottom: 'none',
                            padding: '0px',
                          }
                    }
                    md="3"
                    sm="3"
                    xs="3"
                  >
                    <div className="colFlex">
                      <img src={count > 1 ? GreenTick : DullTick} />
                      <div style={{ marginLeft: '10px' }}>
                        <h1 className="stepText">Step2</h1>
                        <p className="stepTextDetail">Review Skills</p>
                      </div>
                    </div>
                  </Col>
                  <Col
                    style={
                      count > 2
                        ? {
                            display: 'flex',
                            borderBottom: '4px solid #3CA333',
                            padding: '0px',
                          }
                        : {
                            display: 'flex',
                            borderBottom: 'none',
                            padding: '0px',
                          }
                    }
                    className="colFlex"
                    md="3"
                    sm="3"
                    xs="3"
                  >
                    <div className="colFlex">
                      <img src={count > 2 ? GreenTick : DullTick} />
                      <div style={{ marginLeft: '10px' }}>
                        <h1 className="stepText">Step3</h1>
                        <p className="stepTextDetail">Try Again</p>
                      </div>
                    </div>
                  </Col>
                  <Col
                    style={
                      count > 3
                        ? {
                            display: 'flex',
                            borderBottom: '4px solid #3CA333',
                            padding: '0px',
                          }
                        : {
                            display: 'flex',
                            borderBottom: 'none',
                            padding: '0px',
                          }
                    }
                    className="colFlex"
                    md="3"
                    sm="3"
                    xs="3"
                  >
                    <div className="colFlex">
                      <img src={count > 3 ? GreenTick : DullTick} />
                      <div style={{ marginLeft: '10px' }}>
                        <h1 className="stepText">Step4</h1>
                        <p className="stepTextDetail">Check Solution</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
            {count === 1 ? (
              <Step1 updateCount={updateCount} />
            ) : count === 2 ? (
              <Step2 updateCount={updateCount} />
            ) : count === 3 ? (
              <Step3 updateCount={updateCount} />
            ) : count === 4 ? (
              <Step4 />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  );
}
